import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import tagLabel from 'ext:flarum/tags/common/helpers/tagLabel';
import classList from 'flarum/common/utils/classList';
export default class TagChip extends Component {
  get className() {
    const {
      _tag,
      mode,
      className
    } = this.attrs;
    return classList('TagChip', [_tag.color() && 'colored'], [mode === 'add' && 'inactive'], className);
  }
  view() {
    const {
      _tag,
      mode,
      onAdd,
      onRemove
    } = this.attrs;
    const onClick = mode === 'add' ? onAdd : onRemove;
    const icon = mode === 'add' ? 'fas fa-plus' : 'fas fa-minus';
    const attrs = {
      className: this.className
    };
    const color = _tag.color();
    if (color) {
      attrs.style = {
        '--tag-bg': color
      };
    }
    return m("span", attrs, tagLabel(_tag), m(Button, {
      className: "Button Button--flat Button--icon",
      icon: icon,
      onclick: onClick
    }));
  }
}
flarum.reg.add('glowingblue-related', 'forum/components/TagChip', TagChip);